import { Component, Input, OnInit } from "@angular/core";
import { OrganizationModel } from "../models/appsettings/organization.model";
import { ApiService, UserService } from "../services";

@Component({
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
  model: any[];
  @Input() public appMain: any;

  orgInfo: OrganizationModel;

  constructor(
    private readonly userService: UserService,
    private readonly apiService: ApiService
  ) { }

  ngOnInit() {
    this.model = this.getDashboardMenuModel();
    this.orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
    if (!this.orgInfo) {
      this.apiService
        .get("api/Organization")
        .toPromise()
        .then((o) => {
          this.orgInfo = o;
          localStorage.setItem("orgInfo", JSON.stringify(o));
        });
    }
  }

  public getDashboardMenuModel(): any[] {
    const userManagementMenu = [
      { separator: true },
      {
        label: "USER_MANAGEMENT",
        icon: "pi pi-fw pi-star",
        routerLink: ["/dashboard/user-management/users"],
        items: [
          {
            label: "USERS",
            icon: "pi pi-fw pi-user",
            routerLink: ["/dashboard/user-management/users"],
          },
          {
            label: "ROLES",
            icon: "pi pi-fw pi-check-square",
            routerLink: ["/dashboard/user-management/roles"],
          },
          {
            label: "DOCTORS",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/user-management/doctors"],
          },
          {
            label: "TECHNICS",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/user-management/technics"],
          },
          {
            label: "PATIENTS",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/user-management/patients"],
          },
          {
            label: "GENERAL_TIME",
            icon: "pi pi-fw pi-clock",
            routerLink: ["/dashboard/user-management/general-settings"],
          },
        ],
      },
    ];
    const inventoryManagementMenu = [
      { separator: true },
      {
        label: "INVENTORY_MANAGEMENT",
        icon: "pi pi-fw pi-compass",
        routerLink: ["/dashboard/inventory-management"],
        items: [
          {
            label: "INVENTORIES",
            icon: "pi pi-fw pi-list",
            routerLink: ["/dashboard/manuals/inventories"],
          },
          {
            label: "INCOME",
            icon: "pi pi-fw pi-sign-in",
            routerLink: ["/dashboard/inventory-management/income"],
          },
          {
            label: "OUTCOME",
            icon: "pi pi-fw pi-sign-out",
            routerLink: ["/dashboard/inventory-management/outcome"],
          },
        ],
      },
    ];
    const reportsMenu = [
      { separator: true },
      {
        label: "REPORTS",
        icon: "pi pi-fw pi-align-left",
        items: [
          {
            label: "RECEPT_REPORT",
            icon: "pi pi-fw pi-book",
            routerLink: ["/dashboard/reports/recept-report"],
          },
          {
            label: "PARTNERS_REPORT",
            icon: "pi pi-fw pi-tablet",
            routerLink: ["/dashboard/reports/partners-report"],
          },
          {
            label: "DOCTORS_REPORT",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/reports/doctors-report"],
          },
          {
            label: "PATIENTS_REPORT",
            icon: "pi pi-fw pi-table",
            routerLink: ["/dashboard/reports/patients-report"],
          },
          {
            label: "DENTAL_SERVICE_REPORT",
            icon: "pi pi-fw pi-wallet",
            routerLink: ["/dashboard/reports/dental-service-report"],
          },
          {
            label: "DISTRICT_REPORT",
            icon: "pi pi-briefcase",
            routerLink: ["/dashboard/reports/district-report"],
          },
        ],
      },
    ];
    const manualsMenu = [
      { separator: true },
      {
        label: "MANUALS",
        icon: "pi pi-fw pi-compass",
        routerLink: ["/dashboard/manuals"],
        items: [
          {
            label: "DENTAL_SERVICES",
            icon: "pi pi-fw pi-share-alt",
            routerLink: ["/dashboard/manuals/dental-service"],
          },
          {
            label: "DENTAL_SERVICE_GROUPS",
            icon: "pi pi-fw pi-folder",
            routerLink: ["/dashboard/manuals/dental-service-group"],
          },
          {
            label: "DENTAL_SERVICE_CATEGORIES",
            icon: "pi pi-fw pi-folder-open",
            routerLink: ["/dashboard/manuals/dental-service-category"],
          },
          {
            label: "DENTAL_CHAIRS",
            icon: "pi pi-fw pi-folder-open",
            routerLink: ["/dashboard/manuals/dental-chairs"],
          },
          {
            label: "MEASUREMENT_UNITS",
            icon: "pi pi-fw pi-compass",
            routerLink: ["/dashboard/manuals/measurement-unit"],
          },
          {
            label: "PARTNERS",
            icon: "pi pi-fw pi-clone",
            routerLink: ["/dashboard/manuals/partners"],
          },
          {
            label: "PROFESSIONS",
            icon: "pi pi-fw pi-briefcase",
            routerLink: ["/dashboard/manuals/professions"],
          },
          {
            label: "DIAGNOSES",
            icon: "pi pi-fw pi-pencil",
            routerLink: ["/dashboard/manuals/diagnoses"],
          },
          {
            label: "COUNTRIES",
            icon: "pi pi-fw pi-map",
            routerLink: ["/dashboard/manuals/countries"],
          },
          {
            label: "REGIONS",
            icon: "pi pi-fw pi-map-marker",
            routerLink: ["/dashboard/manuals/regions"],
          },
          {
            label: "CITIES",
            icon: "pi pi-fw pi-directions",
            routerLink: ["/dashboard/manuals/cities"],
          },
        ],
      },
    ];
    const appsettingsMenu = [
      { separator: true },
      {
        label: "APP_SETTINGS",
        icon: "pi pi-fw pi-briefcase",
        routerLink: ["/pages"],
        items: [
          {
            label: "TERMS",
            icon: "pi pi-fw pi-percentage",
            routerLink: ["/dashboard/app-settings/terms"],
          },
          {
            label: "RECEPT_INVENTORIES",
            icon: "pi pi-fw pi-slack",
            routerLink: ["/dashboard/app-settings/recept-inventories"],
          },
          {
            label: "TEETH",
            icon: "pi pi-fw pi-apple",
            routerLink: ["/dashboard/app-settings/teeth"],
          },
          {
            label: "ORGANIZATION",
            icon: "pi pi-fw pi-circle-off",
            routerLink: ["/dashboard/app-settings/organization"],
          },
        ],
      },
    ];
    const doctorsMenu = [
      { separator: true },
      {
        label: "WORKSPACE_DOCTOR",
        icon: "pi pi-fw pi-star",
        routerLink: ["/doctor"],
        items: [
          {
            label: "APPOINTMENTS",
            icon: "pi pi-fw pi-calendar-plus",
            routerLink: ["/dashboard/doctor/appointment"],
          },
          {
            label: "RECEPTS",
            icon: "pi pi-fw pi-check-square",
            routerLink: ["/dashboard/doctor/recept"],
          },
          {
            label: "MY_PATIENTS",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/doctor/my-patients"],
          },
          {
            label: "REPORT",
            icon: "pi pi-exclamation-circle",
            routerLink: ["/dashboard/doctor/report"],
          },
          {
            label: "PLAN",
            icon: "pi pi-fw pi-users",
            routerLink: ["/dashboard/doctor/plan"],
          },
        ],
      },
    ];
    const cashiersMenu = [
      { separator: true },
      {
        label: "WORKSPACE_CASHIER",
        icon: "pi pi-fw pi-star",
        routerLink: ["/dashboard/cashier"],
        items: [
          {
            label: "INVOICES",
            icon: "pi pi-fw pi-money-bill",
            routerLink: ["/dashboard/cashier/invoice"],
          },
          {
            label: "PATIENTS_REPORT",
            icon: "pi pi-fw pi-table",
            routerLink: ["/dashboard/cashier/patients-report"],
          },
        ],
      },
    ];
    const receptionMenu = [
      { separator: true },
      {
        label: 'WORKSPACE_RECEPTION',
        icon: 'pi pi-fw pi-star',
        routerLink: ['/dashboard/reception'],
        items: [
          { label: 'SCHEDULES', icon: 'pi pi-fw pi-globe', routerLink: ['/dashboard/reception/doctors-schedule'] },
          { label: 'APPOINTMENTS', icon: 'pi pi-fw pi-file', routerLink: ['/dashboard/reception/appointments'] },
          { label: 'PATIENTS', icon: 'pi pi-fw pi-list', routerLink: ['/dashboard/reception/patient'] }
        ]
      }
    ];
    const rentgenMenu: any[] = [
      {
        label: "WORKSPACE_RENTGEN",
        icon: "pi pi-fw pi-star",
        routerLink: ["/dashboard/rentgen"],
        items: [
          {
            label: "RENTGEN_RECEPTS",
            icon: "pi pi-fw pi-file",
            routerLink: ["/dashboard/rentgen/rentgen-recepts"],
          },
        ],
      },
    ];

    let menuModelList: any[] = [
      ...userManagementMenu,
      ...inventoryManagementMenu,
      ...reportsMenu,
      ...manualsMenu,
      ...appsettingsMenu,
      ...doctorsMenu,
      ...receptionMenu,
      ...cashiersMenu,
      ...rentgenMenu,
    ];

    const userPermissions = this.userService.getPermissions();

    menuModelList.forEach(menu => {
      if (menu.items) {
        menu.items = menu.items.filter(item => {
          return userPermissions.includes(item.label);
        });
      }
    });

    menuModelList = menuModelList.filter(menu => {
      return menu.items && menu.items.length > 0;
    });

    return menuModelList;
  }
}
